/* eslint-disable default-case */
import log from "loglevel";
import prefix from "loglevel-plugin-prefix";
import remote from "loglevel-plugin-remote";
import ClientContext from "./client-context/ClientContext";

var remoteLogShippingFormat = function remoteLogShippingFormat(log) {
  var type = process.env.REACT_APP_TYPE;
  var name = "".concat(process.env.REACT_APP_NAME, " ").concat(type ? type : "Web");
  return {
    level: log.level.label,
    logger: log.logger,
    message: log.message,
    stacktrace: log.stacktrace,
    timestamp: log.timestamp,
    app: name,
    version: process.env.REACT_APP_VERSION
  };
};

export var initLogger = function initLogger(Reactotron) {
  //Setup Reactotron!
  if (process.env.NODE_ENV !== "production" && Reactotron) {
    var originalFactory = log.methodFactory;

    log.methodFactory = function (methodName, logLevel, loggerName) {
      return function (message, obj) {
        switch (methodName.toUpperCase()) {
          case "TRACE":
          case "DEBUG":
          case "INFO":
            Reactotron.display({
              name: methodName.toUpperCase(),
              preview: typeof message === "string" ? message : "",
              value: obj
            });
            break;

          case "WARN":
          case "ERROR":
            {
              var rawMethod = originalFactory(methodName, logLevel, loggerName);
              Reactotron.display({
                name: methodName.toUpperCase(),
                preview: message,
                value: obj,
                important: true
              });
              rawMethod(message, obj);
            }
            break;
        }
      };
    };

    prefix.reg(log); //Apply the custom log pattern

    prefix.apply(log, {
      template: "[%n] :"
    });
  } // Setup Environment Logging Level, default to info


  log.setLevel(process.env.REACT_APP_LOG_LEVEL || "debug");

  if (process.env.NODE_ENV === "production") {
    var appName = "".concat(process.env.REACT_APP_NAME, " ").concat(process.env.REACT_APP_VERSION);
    prefix.reg(log); //Apply the custom log pattern

    prefix.apply(log, {
      template: "[%t] %l (".concat(appName, " - %n) :"),
      timestampFormatter: function timestampFormatter(date) {
        return date.toISOString();
      }
    });
  }

  if (process.env.NODE_ENV === "production" && !process.env.REACT_APP_OFFLINE) {
    //Apply the remote logger - only for production
    // LD-4195 - the android is getting crash without try... catch...
    try {
      remote.apply(log, {
        url: "".concat(process.env.REACT_APP_BASE_PLATFORM_URL).concat(process.env.REACT_APP_STAGE, "/public/log"),
        stacktrace: {
          excess: 1
        },
        headers: {
          "x-api-key": ClientContext._apiKey
        },
        format: remoteLogShippingFormat
      });
    } catch (error) {// error comes here...
    }
  }
};
export { log };